import { Navigate, Outlet } from 'react-router-dom';
import { useCampaignScope } from '@/features/campaigns/model/campaign-scope';

export function PushMarketingLayout() {
  return <Outlet />;
}

export function PushMarketingIndexRedirect() {
  const { listPath } = useCampaignScope();
  return <Navigate to={listPath} replace />;
}
